<template>
  <the-table-page
    :titleTable="$t('Ремарки Sabre')"
    :tableData="tableData"
    :load="load"
    fieldId="id"
    :updateData="updateData"
    :fieldInfoList="fieldInfoList"
    :searchStart="searchStart"
    :sortData="sortData"
    :setSort="setSort"
    :deleteEl="deleteEl"
    :prefixEdit="prefixEdit"
    :prefixShow="prefixShow"
    :linkCreate="linkCreate"
    :configName="configName"
    :roleName="nameRoleEntity"
    :hasReadOnlyInTable="hasReadOnlyInTable"
    :nameTableSaveInCashe="nameTableSaveInCashe" 
  ></the-table-page>
</template>
<script>
import TheTablePage from "../../TheTablePage.vue";
import { SABRE_REMARK } from "./store/type";

import {
  SET_MAIN_PAGINATION,
  SET_MAIN_PAGINATION_PER_PAGE,
  SET_MAIN_PAGINATION_PAGE,
  SET_MAIN_SORT_ENTITY,
  SET_MAIN_SEARCH_ENTITY
} from "../../../../src/store/type";

import { READ, DELETE } from "../../../store/type";
import { mapState } from "vuex";
import NotificationSample from "src/pages/Dashboard/Components/NotificationSample";
import { DEFAULT_PER_PAGE, TYPE_ERRORS , GET_MEMORY_PER_PAGE} from "../../../constant";
import notify from "../../../helpers/notify/notify";
import convertLangDataToTable from "../../../helpers/converters/convertLangDataToTable";
import {NAME_OBJECT} from "../../../RoleConstanans"
export default {
  components: {
    TheTablePage
  },
  props: {
    routeField: { type: String, default: "ContractId" },
    configName: { type: String, default: "creditcard" }, // скорее всего устарело 
    isPersonMode:{ type: Boolean, default: false },
    hasReadOnlyInTable: { type: Boolean, default: true }, 
  },
  data() {
    return {
      load: false
    };
  },
  computed: {
    ...mapState({
      fieldInfoList: state => state.sabreRemark.fieldInfoList,
      lang: state => state.common.lang,
      sortData: state => state.pagination.sortData
    }),
    nameRoleEntity(){
      return NAME_OBJECT.sabreRemark
    },
    tableData() {
      let langNow = this.$store.state.common.lang;
      let dataNow = this.$store.state.sabreRemark.data || [];
      if (dataNow && dataNow.length > 0) {
        dataNow = convertLangDataToTable(dataNow, langNow, "", false);
        return dataNow;
      }
    },
    prefixEdit() {
      const route = this.$route;
      if(this.isPersonMode){
       return  `/contract/${route.params.ContractId}/person/${route.params.PersonId}/sabreRemark`
      }
      return `/contract/${route.params.ContractId}/sabreRemark`;
    },
    prefixShow() {
      return this.prefixEdit;
    },
    linkCreate() {
      return this.prefixEdit + "/create";
    },
    nameTableSaveInCashe() {
      let name = this.$route.name
      return name == "ShowPerson" ? 'personeRemark'+"--"+this.$route.path:'contractRemark'+"--"+this.$route.path 
    }
  },
  watch: {
    lang() {
      this.initData();
    }
  },
  methods: {
    getData() {
      this.load = true;
      this.$store
        .dispatch(SABRE_REMARK + READ, {
          self: this,
          SubjectId: this.isPersonMode? this.$route.params.PersonId : this.$route.params[this.routeField],
          ParamCode: 'SabreRemark'
        })
        .then(res => {
          this.load = false;
        })
        .catch(err => {
          this.load = false;
          notify(this, this.$t("Ошибка получения данных"), TYPE_ERRORS.DANGER);
        });
    },
    updateData() {
      this.getData();
    },
    searchStart(search) {
      this.$store.commit(SET_MAIN_SEARCH_ENTITY, search);
      this.getData();
    },
    setSort(val) {
      this.$store.commit(SET_MAIN_SORT_ENTITY, val);
      this.getData();
    },
    deleteEl(id) {
      this.$store
        .dispatch(SABRE_REMARK + DELETE, {
          SubjectId: this.isPersonMode? this.$route.params.PersonId : this.$route.params[this.routeField],
          ParamCode: 'SabreRemark',
          SubjectParamId: id,
          self: this
        })
        .then(res => {
          this.getData();
             if(res.errors && res.errors.length  == 0){notify(this, this.$t("Успешно"),TYPE_ERRORS.SUCCESS); }
        });
    },
    initData() {
      this.$store.commit(SABRE_REMARK + READ, { data: [], fieldInfoList: [] });
      this.$store.commit(SET_MAIN_SORT_ENTITY, {});
      this.$store.commit(SET_MAIN_SEARCH_ENTITY, "");
      this.$store.commit(SET_MAIN_PAGINATION_PER_PAGE, GET_MEMORY_PER_PAGE());
      this.$store.commit(SET_MAIN_PAGINATION_PAGE, 1);
      let name = this.nameTableSaveInCashe ? this.nameTableSaveInCashe : null;
      this.$store.dispatch("SET_OLD_PAGINATION", name)
      this.getData();
    }
  },
  created() {
    this.initData();
  }
};
</script>
